import styled from 'styled-components'

const ComponentStyled = styled.div`
  position: relative;
  padding: 24px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: ${({ theme }) => theme.colors.secondaries.opacity10};
  text-align: center;

  .close {
    position: absolute;
    right: 24px;
    cursor: pointer;
  }

  .modal-header-title {
    font-family: 'Cabin';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.11em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.black};
  }

  .modal-title {
    font-family: 'Playfair Display';
    font-weight: 900;
    font-size: 32px;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.colors.black};
  }

  .modal-description {
    font-family: 'Cabin';
    font-weight: 400;
    font-size: 18px;
    line-height: 29px;
    color: ${({ theme }) => theme.colors.black};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .modal-header-title {
      font-size: 14px;
      line-height: 17px;
    }

    .modal-title {
      font-size: 24px;
      line-height: 24px;
    }

    .modal-description {
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export default ComponentStyled
